import React from 'react'
import ContentLoader from 'react-content-loader'
import classes from './SearchCardLoader.module.css'

const SearchCardLoader = () => {
    return (
        <ContentLoader className={classes.loader}>
            <rect
                width={'200px'}
                height={'148px'}
                x={'14px'}
                y={'16px'}
                rx={'5px'}
                ry={'5px'}
            />
            <rect
                width={'200px'}
                height={'14px'}
                x={'252px'}
                y={'20px'}
                rx={'2px'}
                ry={'2px'}
            />
            <rect
                width={'70px'}
                height={'14px'}
                x={'calc(100% - 105px)'}
                y={'20px'}
                rx={'2px'}
                ry={'2px'}
            />
            <rect
                width={'120px'}
                height={'14px'}
                x={'252px'}
                y={'44px'}
                rx={'2px'}
                ry={'2px'}
            />
            <rect
                width={'140px'}
                height={'10px'}
                x={'252px'}
                y={'calc(100% - 34px)'}
                rx={'2px'}
                ry={'2px'}
            />
            <rect
                width={'140px'}
                height={'10px'}
                x={'430px'}
                y={'calc(100% - 34px)'}
                rx={'2px'}
                ry={'2px'}
            />
        </ContentLoader>
    )
}

export default SearchCardLoader
